export default __webpack_public_path__ + "static/media/gmail.23dc51c2.svg";